import OrderInfo from '@/components/OrdersModule/OrderDetail/Header/OrderInfo'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { getFullDeliveryAddress } from '@/utils/getFullDeliveryAddress'
import parsePhoneNumber from 'libphonenumber-js'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import invariant from 'tiny-invariant'

interface OrderAndCustomerInfoProps {
    uuid: string
}

const OrderAndCustomerInfo: FC<OrderAndCustomerInfoProps> = ({ uuid }) => {
    const order = useAppSelector(ordersSelectors.orderByUuid(uuid))

    const { t } = useTranslation()

    invariant(order, 'Order must be set')

    const address = order.deliveryAddress
        ? getFullDeliveryAddress(order.deliveryAddress?.street, order.deliveryAddress?.city)
        : undefined
    const phoneNumber = order.phoneNumber
        ? (parsePhoneNumber(order.phoneNumber, { extract: false })?.formatInternational() ??
          order.phoneNumber)
        : undefined

    return (
        <OrderInfo
            deliveryTime={order.acceptedDeliveryTime ?? order.requestedDeliveryTime}
            phoneNumber={phoneNumber}
            address={address}
            paymentType={order.paymentType && t(`orders.paymentType.${order.paymentType.type}`)}
            customerNote={order.customerNote}
        />
    )
}

export default OrderAndCustomerInfo
